import {
  ICON_DEFAULT_COLOR,
  ICON_DEFAULT_FILL,
  ICON_DEFAULT_HEIGHT,
  ICON_DEFAULT_VIEWBOX,
  ICON_DEFAULT_WIDTH,
  IconProps
} from 'components'
import { ComponentProps } from 'react'

export const ClearAll = ({
  color = ICON_DEFAULT_COLOR,
  fill = ICON_DEFAULT_FILL,
  width = ICON_DEFAULT_WIDTH,
  height = ICON_DEFAULT_HEIGHT,
  viewBox = ICON_DEFAULT_VIEWBOX,
  ...props
}: ComponentProps<'svg'> & Omit<IconProps, 'icon'>) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M28.8178 37.4543L45.7709 20.5011C46.6489 19.6216 47.1419 18.4296 47.1419 17.1869C47.1419 15.9442 46.6489 14.7523 45.7709 13.8727L36.1267 4.22974C35.2472 3.35183 34.0552 2.85876 32.8125 2.85876C31.5698 2.85876 30.3778 3.35183 29.4983 4.22974L12.5452 21.1829C11.9852 21.7453 11.5776 22.441 11.3609 23.2045C11.1441 23.968 11.1253 24.7742 11.3063 25.5469L4.83252 32.0207C3.95458 32.9008 3.46155 34.0932 3.46155 35.3364C3.46155 36.5795 3.95458 37.7719 4.83252 38.6521L11.3481 45.1677C11.7854 45.6052 12.3052 45.9516 12.8774 46.1867C13.4495 46.4217 14.0627 46.5408 14.6813 46.5371C14.9466 46.7566 15.2806 46.8762 15.625 46.875H37.5C37.9144 46.875 38.3118 46.7104 38.6049 46.4174C38.8979 46.1244 39.0625 45.7269 39.0625 45.3125C39.0625 44.8981 38.8979 44.5007 38.6049 44.2077C38.3118 43.9147 37.9144 43.75 37.5 43.75H19.397L24.4533 38.6938C25.2262 38.8747 26.0324 38.8559 26.796 38.639C27.5596 38.4221 28.2554 38.0144 28.8178 37.4543ZM7.04268 36.4425C6.74976 36.1489 6.58525 35.7511 6.58525 35.3363C6.58525 34.9215 6.74976 34.5237 7.04268 34.23L13.0044 28.2685L21.7324 36.9964L15.7708 42.9582C15.4721 43.2411 15.0763 43.3987 14.6649 43.3987C14.2534 43.3987 13.8577 43.2411 13.5589 42.9582L7.04268 36.4425Z"
        fill={color}
      />
    </svg>
  )
}
